<template>
    <div class="flex-column">
        <v-toolbar class="shadow-none" content-class="h-auto">
            <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_SignSendRule")}} - {{ nameOfSelectedStructure }}</v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div class="border-top p-4 flex-1 d-flex flex-column overflow-auto">
        <div class="d-flex flex-wrap flex-fill">
            <div class="flex-1">
                <v-label class="label_required mb-2">{{ $t("res_Label_SelectStructure")}}<span> *</span></v-label>
                <div class="">
                    <StructureUserSelector :showInternalUsers="false" :showInternalStructures="true" 
                        :showExternalStructures="false" :showStructuresOnlyPerEntity="true"
                        :companyId="companyId" :excludeSelf="false" :isMultiple="false" :includeWorkflowParticipants="true"
                        :selectedStructureUser="sign_send_rule_obj.structure" @structureUserSelectChanged="selectStructure">
                    </StructureUserSelector>
                </div>
            </div>
            <div class="flex-1">
                <label>{{ $t("res_Label_SelectType")}} *</label>
                <multiselect class="light-bg" v-model="sign_send_rule_obj.type" label="text" track-by="id" open-direction="bottom"
                    :placeholder="$t('res_Label_Select')" :options="structureTypes" :searchable="true" :loading="loading" :internal-search="false"
                    :clear-on-select="true" :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                    :hide-selected="false" :multiple="false">
                </multiselect>
            </div>
            <div class="flex-1">
                <label>{{ $t("res_Label_SelectCategory")}} *</label>
                <multiselect class="light-bg"
                    v-model="sign_send_rule_obj.category"
                    :label="language == 'en' ? 'name' : 'nameAr'"
                    track-by="id"
                    open-direction="bottom"
                    :placeholder="$t('res_Label_Select')"
                    :options="structureCategories"
                    :searchable="true"
                    :loading="loading"
                    :internal-search="false"
                    :clear-on-select="true"
                    :close-on-select="true"
                    :options-limit="300"
                    :max-height="600"
                    :show-no-results="false"
                    :hide-selected="false"
                    :multiple="false"
                >
                </multiselect>
            </div>
        </div>
      <div class="actions d-flex">
        <v-btn
          color="primary"
          dense
          @click="updateSelectedRow"
          v-if="showUpdate"
          >{{ $t("res_ButtonText_Update")}}</v-btn
        >
        <v-btn
          color="primary"
          dense
          @click="postSignAndSendRule"
          v-if="!showUpdate"
          >{{ $t("res_ButtonText_Save")}}</v-btn
        >
        <v-btn
          color="light-blue"
          dense
          @click="reset"
          >{{ $t("res_ButtonText_Reset")}}</v-btn
        >
      </div>

      <div class="flex-1">
        <v-data-table
          class="position-relative white h-100 d-flex flex-column"
          disable-sort
          :headers="headers"
          :items-per-page="10"
          :items="signSendData"
          :loading="loadingData"
          loading-text="loading..."
          :no-data-text="$t('res_Label_NoData')"
          :footer-props="{ 'items-per-page-text': 'Items per page' }"
          caption=""
          :class="{'result_available': signSendData.length != 0}"
          header-fixed
          fixed-header
        >
          <template v-slot:item="row">
            <tr>
              <td style="display: none">{{ row.item.id }}</td>
              <td>{{ row.item.categoryName }}</td>
              <td>{{ row.item.type == '1' ? 'TO' : 'CC' }}</td>
              <td>{{ row.item.structureName }}</td>
              <td>
                <div class="onhover-display">
  <div class="custom-icon-wrapper">
    <v-icon @click="editSelectedRow(row.item)">custom-icon white-bg edit-icon</v-icon>
                  </div>
                  <div class="custom-icon-wrapper">
                    <v-icon @click="deleteSelectedRow(row.item.id)">custom-icon white-bg delete-icon</v-icon>
                </div>
</div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import constants from '@/assets/js/constants'
    import Multiselect from 'vue-multiselect'
	import * as utils from '@/assets/js/common.js'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'

    export default {
        name: 'SendSignRule',
        components: { Multiselect, StructureUserSelector },
        data() {
            return {
                select_localize: this.$t("res_Label_Select"),
                loadingData: true,
                selectedRow: 0,
                updateBody: {},
                showUpdate: false,
                structureValueItems: [],
                structureTypes: [{ id: '1', text: 'TO' }, { id: '2', text: 'CC' }],
                structureCategories: [],
                headers: [
                    { text: 'Id', align: ' d-none', value: 'id', width: '10%' },
                    { text: this.$t("res_GridHeaders_Category"), value: 'categoryName', width: '20%' },
                    { text: this.$t("res_GridHeaders_Type"), value: 'type', width: '15%' },
                    { text: this.$t("res_GridHeaders_Structure"), width: '35%' },
                    { text: this.$t("res_GridHeaders_Actions"), value: 'event', width: '20%', sortable: false },
                ],
                signSendData: [],
                sign_send_rule_obj:
                {
                    type: { id: '0', text: '' },
                    category: { id: '0', text: '' },
                    structure: null,
                }
            };
        },
        props: {
            structure_id: Number,
            nameOfSelectedStructure: { type: String, default: '' },
            companyId: { type: Number, default: 0 },
            language: { type: String, default: 'en'},
        },
        methods:
        {
            fetchSignAndSendRule() 
            {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'SignSendRule/GetStructureSignSendRules?structureId=' + this.structure_id)
                    .then(res => 
                    {
                        this.signSendData = res.data;
                        this.loadingData = false;
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            postSignAndSendRule() 
            {
                var data = {
                    StructureId: this.structure_id,
                    CategoryId: this.sign_send_rule_obj.category.id,
                    Type: this.sign_send_rule_obj.type.id,
                    Value: this.sign_send_rule_obj.structure?.id ?? null
                }

                if (data.CategoryId == '0' || data.Type == '0' || data.Value == '' || this.sign_send_rule_obj.structure?.id == null) 
                {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                    return
                }
                window.showLoading()
                axios.post(constants.baseApiUrl + 'SignSendRule/InsertStructureSignSendRule', data)
                    .then(res => 
                    {
                        window.showAlert("A new sign and send rule was successfully added", 'success')
                        this.fetchSignAndSendRule()
                        this.reset()
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            reset() 
            {
                this.sign_send_rule_obj = { type: { id: '0', text: '' }, category: { id: '0', text: '' }, structure: { id: '', name: '' } }
                this.showUpdate = false
            },
            editSelectedRow(row) 
            {
                this.reset()
                if (row.type != undefined && row.type != null)
                    this.sign_send_rule_obj.type = this.structureTypes.find(x => x.id == row.type)

                if (row.categoryId != undefined && row.categoryId != null)
                    this.sign_send_rule_obj.category = this.structureCategories.find(x => x.id == row.categoryId)

                if (row.value != undefined && row.value != null)
                    this.sign_send_rule_obj.structure = { id: row.value, name: row.structureName, isUser: false }

                this.selectedRow = row.id
                this.showUpdate = true
            },
            deleteSelectedRow(id) 
            {
                window.showInformation(this.$t('res_Msgs_Confirmation'),this.$t('res_Msgs_DeleteSignAndSendRule'), () => 
                {
                    window.showLoading()
                    axios.post(constants.baseApiUrl + 'SignSendRule/DeleteStructureSignSendRule?signSendRuleId=' + id, null)
                    .then(res => 
                    {
                        window.showAlert(this.$t("res_Msgs_SuccessDeleteSign"), 'success')
                        this.fetchSignAndSendRule()
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading());
                }, () => { })
            },
            updateSelectedRow() 
            {
                if (this.sign_send_rule_obj.type == null || this.sign_send_rule_obj.type == undefined || this.sign_send_rule_obj.type.id == '0'
                    || this.sign_send_rule_obj.category == null || this.sign_send_rule_obj.category == undefined || this.sign_send_rule_obj.category.id == '0'
                    || this.sign_send_rule_obj.structure == null || this.sign_send_rule_obj.structure == undefined || this.sign_send_rule_obj.structure.id == '') 
                {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                    return
                }

                var data = {
                    Id: this.selectedRow,
                    StructureId: this.structure_id,
                    CategoryId: this.sign_send_rule_obj.category.id,
                    Type: this.sign_send_rule_obj.type.id,
                    Value: this.sign_send_rule_obj.structure?.id ?? null
                }
                window.showLoading()
                axios.post(constants.baseApiUrl + 'SignSendRule/UpdateStructureSignSendRule', data)
                    .then(res => 
                    {
                        this.showUpdate = false
                        this.loadingData = true
                        this.fetchSignAndSendRule()
                        this.reset()
                        this.showUpdate = false
                        window.showAlert('The selected sign and send rule was successfully updated', 'success')
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            selectStructure(item) {
                this.sign_send_rule_obj.structure = item;
            },
            CapitalizeFirstLetter(str)
            {
				return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options)
            {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            }
        },
        mounted() 
        {
            this.fetchSignAndSendRule()
            this.structureCategories = constants.categories.filter(x => x.id != constants.categoriesEnum.Incoming)
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>